Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-wishlist-merchant-widget');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var model = null;

    var openWidget = false;

    wrapper.open = function () {
        $(".js-widget-trigger", $wrapper).addClass('x-open');
        $(".js-widget-container", $wrapper).addClass('x-expanded');

        openWidget = false;
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.WidgetOpened(Vendd.Widget.WishlistMerchantWidget));
    };

    wrapper.close = function () {
        $(".js-widget-trigger", $wrapper).removeClass('x-open');
        $(".js-widget-container", $wrapper).removeClass('x-expanded');
    };

    wrapper.loading = function (loading) {
        if (loading) {
            $(".js-widget-container", $wrapper).addClass('x-loading');
        } else {
            $(".js-widget-container", $wrapper).removeClass('x-loading');
        }
    };

    wrapper.update = function () {

        var html = Vendd.Handlebars.parse("wishlistMerchantWidget", model);
        wrapper.bind(html);

        wrapper.loading(false);
    };

    wrapper.bind = function (html) {
        $wrapper.html(html);

        var $list = $('.x-wishlist-list', $wrapper);
        var $items = $('.wishlist-item', $list);

        if ($items.length > 3) {
            $list.cycle({
                slides: '> li',
                fx: 'carousel',
                timeout: 0,
                prev: '.x-wishlist-merchant-widget .nav-btn.prev-vertical',
                next: '.x-wishlist-merchant-widget .nav-btn.next-vertical',
                log: false,
                carouselVertical: true,
                carouselVisible: 3,
                allowWrap: false,
                disabledClass: 'disabled'
            });
            $('.nav-btn', $wrapper).show().css("display", "block");
        }

        if (openWidget) {
            $('html, body').animate({ scrollTop: $wrapper.offset().top }, 600);
            wrapper.open();
        }

        wrapper.loading(false);
    };

    $wrapper.on('click', '.js-remove', function (e) {
        e.preventDefault();

        var $this = $(this);
        var $item = $this.closest('.wishlist-item');
        var id = $item.data('merchant-id');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.WishlistMerchant.Messages.Remove(id));
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.WishlistMerchantWidget, false));
    });

    $wrapper.on('click', '.js-widget-trigger', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('x-open')) {
            wrapper.close();
        } else {
            wrapper.open();
        }
    });


    $wrapper.on('click', function (e) {
        e.stopPropagation();
    });

    $('body').on('click', function (e) {
        wrapper.close();
    });

    Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data;

        wrapper.loading(true);

        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.WidgetOpened, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.WishlistMerchantWidget) {
            wrapper.close();
        };
    });

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.OpenWidget, wrapper, function (envelope) {
        if (envelope.message.data.widgetName !== Vendd.Widget.WishlistMerchantWidget) {
            if (envelope.message.data.immediate === true)
                wrapper.open();
            else
                openWidget = true; 
        }
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.WishlistMerchant.Messages.GetModel());
});

